import { STORE_MENU_LIST, REDUCE_MENU_LIST, CLEAR_MENU_LIST } from "../actions";

export function storeMenuList(payload) {
  return {
    type: STORE_MENU_LIST,
    payload
  };
}

export function reduceMenuList(immutableMenuList, options) {
  return {
    type: REDUCE_MENU_LIST,
    payload: {
      immutableMenuList,
      ...options
    }
  };
}

export function clearMenuList() {
  return {
    type: CLEAR_MENU_LIST
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/menuList.js